import React from "react";
import firebase from "firebase";
import { connect } from "react-redux";
import { storage } from "../app-database";

const mapState = (state) => {
	return {
		loading: state.global.loader,
		poliza: state.polizas.poliza,
		cveCliente: state.global.uid
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (titulo, mensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": titulo, "mensaje": mensaje})
		}
	};
};

class TarjetaCirculacion extends React.Component {
	
	state = {
		edicion: false,
		tcFile: false,
		tcUrl: false,
		tmpUrl: false,
		spanClass: "upload-wrap"
	}
	
	editar = () => {
		this.setState({edicion: !this.state.edicion});
	}
	
	cancelar = () => {
		this.editar();
		this.setState({tcUrl: this.state.tmpUrl, spanClass: (this.state.tmpUrl)?"upload-wrap uploaded-file":"upload-wrap"});
	}
	
	borrar = () => {
		this.setState({tcFile: false, tcUrl: false, spanClass: "upload-wrap"});
	}
	
	guardar = () => {
		let $this = this;
		let storageRef = storage.ref("documentos/" + this.props.cveCliente + "/" + this.props.poliza.generales.numPoliza);    
		
		if(this.state.tcFile && this.state.tcFile.name) {
			this.props.loader(true);
			
			let uploadTaskTC = storageRef.child("tarjeta_circulacion.jpg").put(this.state.tcFile, { contentType: "image/jpeg" });
			uploadTaskTC.on(firebase.storage.TaskEvent.STATE_CHANGED, function(snapshot) {
				var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				console.log("Upload is " + progress + "% done");
			}, function(error) {
				console.log(error.code);
				$this.props.loader(false);
				$this.props.alerta("Error","Ocurrio un error al actualizar el documento. " + error.code);
			}, function() {
				console.log(uploadTaskTC.snapshot.downloadURL);
				$this.setState({tcUrl: uploadTaskTC.snapshot.downloadURL,  tmpUrl: uploadTaskTC.snapshot.downloadURL, tcFile: false});
				$this.props.loader(false);
				$this.editar();
			});
		} else if(this.state.tcUrl == false && this.state.tcFile == false && this.state.tmpUrl != false) {
			this.props.loader(true);
			
			storageRef.child("tarjeta_circulacion.jpg").delete().then(function() {
				$this.setState({tmpUrl: false});
				$this.props.loader(false);
				$this.editar();
			}).catch(function(error) {
				console.log(error);
				$this.props.loader(false);
				$this.props.alerta("Error","Ocurrio un error al actualizar el documento. " + error.code);
			});
		} else {
			this.cancelar();
		}
	}
	
	changeInputFile = (event) => {
		let reader = new FileReader();
		let file = event.target.files[0];
		let ext = file.name.split(".").pop().toLowerCase();
		
		if(ext == "jpg" || ext == "png" || ext == "bmp" || ext == "jpeg") {
			reader.onloadend = () => {
				this.setState({tcFile: file});
				this.setState({tcUrl: reader.result});
				this.setState({spanClass: "upload-wrap uploaded-file"});
			};
			reader.readAsDataURL(file);
			
			this.refs.tarjetaCirculacion.value="";
		} else {
			this.props.alerta("Error","El documento debe ser una imagen en formato: jpg, png o bmp.");
		}
	}
	
	componentWillMount = () => {
		let $this = this;
		let pathReference = storage.ref("documentos/" + this.props.cveCliente + "/" + this.props.poliza.generales.numPoliza).child("tarjeta_circulacion.jpg");
		
		pathReference.getDownloadURL().then(function(url) {
			$this.setState({tcUrl: url, tmpUrl: url, spanClass: "upload-wrap uploaded-file"});
		}).catch(function(error) {
			console.log(error.code);
		});
	}
	
	render() {
		let imgTarjetaCirculacion = require("../img/circle-tarjeta-circulacion.svg");
		
		return (
			<div className="card perfil-card mt-34">
				<div className="card-header" style={{"paddingTop":"0px"}}>
					<div className="row">
						<div className="col-xs-8">
							<i><img src={ imgTarjetaCirculacion } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Tarjeta de circulación</span>
						</div>
						<div className="col-xs-4">
							<div className="text-right card-actions-btn">
								{ !this.state.edicion &&
									<a id="doc_edit" onClick={this.editar} className="orange-btn" style={{"display":"inline-block","margin":"3px 0px"}}>Editar <img src={ require("../img/editar-icono.png") } /></a>
								}
								{ this.state.edicion &&
									<div>
										<a id="doc_cancel" onClick={this.cancelar} className="pad-right-10" style={{"display":"inline-block","margin":"3px 0px"}}>Cancelar</a>
										<a id="doc_acept" onClick={this.guardar} className="orange-btn" style={{"display":"inline-block","margin":"3px 0px"}}>Guardar</a>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 mt-25">
						<div className="row">
							<div className="col-xs-12 text-center">
								<span className={this.state.spanClass}>
									<i className="upload-icon"></i>
									<input id="fileTarjetaCirculacion" ref="tarjetaCirculacion" type="file" disabled={!this.state.edicion} onChange={this.changeInputFile} />
									{ this.state.tcUrl &&
										<a href={this.state.tcUrl} target="_blank">
											<img src={this.state.tcUrl} />
										</a>
									}
								</span>
								{ this.state.edicion && this.state.tcUrl &&
									<button id="borrarTarjetaCirculacion" onClick={this.borrar}>X</button>
								}
								<p className="text-center">{/*Tarjeta de circulación*/}</p>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(TarjetaCirculacion);


// WEBPACK FOOTER //
// ./src/home/tarjetaCirculacion.cmpt.js